import { type FormEvent, type FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { DriverDataSuccessResponse } from "@App/apis/rest/ayvens/driverData/responses/driverDataSuccessResponse";
import { Button } from "@App/Components/Funnel/Button";

export type AgentDriverDataVerificationFormProps = {
  driverData: DriverDataSuccessResponse;
  onCancel: () => void;
  onSubmit: () => void;
};

export const AgentDriverDataVerificationForm: FunctionComponent<
  AgentDriverDataVerificationFormProps
> = ({ driverData, onCancel, onSubmit }: AgentDriverDataVerificationFormProps) => {
  const { t } = useTranslation();

  const handleVerification = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onSubmit();
  };

  return (
    <form onSubmit={handleVerification} className="space-y-6" noValidate>
      {" "}
      {/* Added noValidate to prevent browser default validation popups */}
      <div className="mt-2">
        <div className="text-l">{t("vehicleSelector.isRightVehicle")}</div>
      </div>
      <div className="mt-2">
        <div className="rounded-md bg-secondary p-4">
          <div className="flex">
            <div className="ml-3">
              <h3 className="text-sm font-medium text-white">
                {driverData.keyNumber
                  ? `${driverData.keyNumber.type.generation.brand.name} ${driverData.keyNumber.type.generation.name} ${driverData.keyNumber.type.name}`
                  : driverData.vehicle.description}
              </h3>
              <div className="mt-2 text-sm text-white">
                <p>{`${t("vehicleSelector.numberPlate")}: ${driverData.vehicle.numberPlate}`}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={"grid grid-cols-2 gap-4"}>
        <Button
          title={t("vehicleSelector.backToNumberPlateSelection")}
          width={"md:w-full"}
          onClick={onCancel}
          outline
        />
        <Button title={t("vehicleSelector.submit")} width={"md:w-full"} type={"submit"} />
      </div>
    </form>
  );
};
